import { render, staticRenderFns } from "./instructionsPop.vue?vue&type=template&id=b6fbd10a&scoped=true&"
import script from "./instructionsPop.vue?vue&type=script&lang=js&"
export * from "./instructionsPop.vue?vue&type=script&lang=js&"
import style0 from "./instructionsPop.vue?vue&type=style&index=0&id=b6fbd10a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fbd10a",
  null
  
)

export default component.exports